// extracted by mini-css-extract-plugin
export default {"footer":"WarningModal__footer___KcuFc","tabsWrapper":"WarningModal__tabsWrapper___KoZKH","feedListWrapper":"WarningModal__feedListWrapper___ET5jX"};